import React, { useState } from 'react';

// Styles
import styles from "../DashboardFileManagement.module.css"

import AddCallModal from './AddCallModal';

// Images
import addIconBlue from "./../../../../assets/img/DashboardICons/AddIconBlue.svg";

const ConsultantReportsTable = ({ id, consultanID, callReport }) => {
    const [showModal, setShowModal] = useState(false)
    return (
        <>
            <AddCallModal
                show={showModal}
                onHide={() => setShowModal(false)}
                EstateId={id}
                UserId={consultanID}
            />
            <div className="py-2">
                <div className="container-fluid" style={{minHeight: "300px"}}>
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                        dir="rtl"
                    >
                        <div className={`mb-4 w-100`}>
                            <div>
                                <img className={`px-1`} src={addIconBlue} alt="add-icon-blue" />
                                <button className={`border-0 bg-transparent px-2 ${styles.text_primary}`} onClick={() => setShowModal(true)}> ثبت تماس جدید </button>
                            </div>
                        </div>

                        <table className="table" style={{ textAlign: "center" }}>
                            <thead>
                                <tr>
                                    {/* <th scope="col" className={styles.table_head_th}>تعداد</th> */}
                                    <th scope="col" className={styles.table_head_th}>شماره تماس</th>
                                    <th scope="col" className={styles.table_head_th}>نام و نام‌خانوادگی</th>
                                    <th scope="col" className={styles.table_head_th}>زمان تماس</th>
                                </tr>
                            </thead>
                            <tbody>
                                {callReport?.map((item, i) => (
                                    <tr key={i}>
                                        {/* <th scope="row" className={styles.table_th} style={{ border: "none" }}>۰۱</th> */}
                                        <td className={styles.table_th} style={{ border: "none" }}>{item.phoneNumber?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}</td>
                                        <td className={styles.table_th} style={{ border: "none" }}>{item.callerName}</td>
                                        <td className={`d-flex align-items-center justify-content-center ${styles.table_th}`} style={{ border: "none" }}>
                                            {item.callDate?.toString()}
                                            <div className={styles.rounded_green}></div>
                                            {item.callTime?.toString()}
                                        </td>
                                    </tr>
                                ))

                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConsultantReportsTable;